<template>
  <div class="text-left">
    <div v-if="componentReady">
      <h5 v-text="t('forms.new_contractor_numemployees.IC_0000')"/>
      <hr>

      <div class="panel">
        <p v-if="!isAfricaCountry">
          <span v-text="t('forms.new_contractor_numemployees.IC_0001')"/>
          <span class="required">*</span>
        </p>

        <p v-if="isAfricaCountry">
          <span v-text="t('forms.new_contractor_numemployees2.IC_0001')"/>
          <span class="required">*</span>
        </p>
      </div>

      <div v-if="!isAfricaCountry">
        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="14">
            {{ t('forms.offices_employees_choice.MemberType100') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="15">
            {{ t('forms.offices_employees_choice.MemberType101') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="16">
            {{ t('forms.offices_employees_choice.MemberType102') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="17">
            {{ t('forms.offices_employees_choice.MemberType103') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="18">
            {{ t('forms.offices_employees_choice.MemberType104') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="19">
            {{ t('forms.offices_employees_choice.MemberType105') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="20">
            {{ t('forms.offices_employees_choice.MemberType106') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="21">
            {{ t('forms.offices_employees_choice.MemberType107') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="22">
            {{ t('forms.offices_employees_choice.MemberType108') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="23">
            {{ t('forms.offices_employees_choice.MemberType109') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="24">
            {{ t('forms.offices_employees_choice.MemberType110') }}
          </label>
        </div>
      </div>

      <div v-if="isAfricaCountry">
        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="6">
            {{ t('forms.new_contractor_numemployees2.IC_0003') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="7">
            {{ t('forms.new_contractor_numemployees2.IC_0004') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="8">
            {{ t('forms.new_contractor_numemployees2.IC_0005') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="9">
            {{ t('forms.new_contractor_numemployees2.IC_0006') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="10">
            {{ t('forms.new_contractor_numemployees2.IC_0007') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="11">
            {{ t('forms.new_contractor_numemployees2.IC_0008') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="12">
            {{ t('forms.new_contractor_numemployees2.IC_0009') }}
          </label>
        </div>

        <div>
          <label>
            <input
              v-model="localData.memberInfo.NumEmpl"
              type="radio"
              value="13">
            {{ t('forms.new_contractor_numemployees2.IC_0010') }}
          </label>
        </div>
      </div>

      <div>
        <small
          v-if="displayError"
          class="error"
          v-text="'You must enter a peak number of employees'"/>
      </div>

      <div
        class="row"
        style="margin-top: 30px;">
        <div class="columns small-12 text-center">
          <button
            class="tiny navBtn"
            @click="checkComplete()"
            v-text="t('forms.new_blank_reference_member.IC_0024')"/>
        </div>
      </div>

    </div>

    <div v-if="!componentReady">
      <i class="fa fa-spinner fa-spin fa-2x"/>
    </div>

  </div>

</template>

<script>
import $ from 'jquery';
import _ from 'lodash';

export default {
  data() {
    return {
      localData: {},
      componentReady: false,
      isAfricaCountry: false,
      displayError: false,
    };
  },

  watch: {
    'localData.memberInfo.NumEmpl': function () {
      this.saveEmployees();
    },
  },

  beforeMount() {
    $.post('/register/is-africa', (isAfricaCountry) => {
      this.isAfricaCountry = isAfricaCountry;
      $.post('/register/tab-data/company', (data) => {
        this.localData = data;
        this.componentReady = true;
      });
    }).fail(() => {
      window.location.href = '/register';
    });
  },

  methods: {
    checkComplete() {
      if (_.isEmpty(this.localData.memberInfo.NumEmpl)) {
        this.displayError = true;
        return;
      }

      this.displayError = false;
      this.$emit('complete');
    },

    saveEmployees() {
      $.post('/register/save-company', {
        memberInfo: this.localData.memberInfo,
      });
    },
  },
};
</script>
